const EndorsementCurrentStateDocument = ({
  name,
  document,
  deadline,
  startDateValidity,
  endDateValidity,
  contractValue,
  guaranteeValue,
  objectText,
  historyDocuments,
}) => ({
  name: name ?? '',
  document: document ?? '',
  deadline: deadline ?? '',
  startDateValidity: startDateValidity ?? '',
  endDateValidity: endDateValidity ?? '',
  contractValue: contractValue ?? 0,
  guaranteeValue: guaranteeValue ?? 0,
  objectText: objectText ?? '',
  historyDocuments: historyDocuments ?? [],
})

export default EndorsementCurrentStateDocument
